import loadDocxKitModules from '@Infra/DocxKit/loadDocxKitModules';

/** Resolves once the docx-kit WebAssembly modules are ready; the only path from `UI/` to the loader. */
const ensureDocxKitModules = (): Promise<void> => {
	return loadDocxKitModules();
};

export default ensureDocxKitModules;
